
define('text!templates/widgets/dataGridCells/checkedCell.html',[],function () { return '<div data-bind="if: value">\n    <i class="fa fa-check"></i>\n    <span class="sr-only" data-bind="lString: &apos;checkedCell.checked&apos;"></span>\n</div>\n';});

